import {P2} from '@/componentLibrary/components/typography';
import {ColorFgSubtle} from '@/componentLibrary/tokens/variables';

export const InvalidTime = () => <P2 color={ColorFgSubtle}>N/A</P2>;
